import { render, staticRenderFns } from "./ClaimSubmitModal.vue?vue&type=template&id=56d44518&"
import script from "./ClaimSubmitModal.vue?vue&type=script&lang=js&"
export * from "./ClaimSubmitModal.vue?vue&type=script&lang=js&"
import style0 from "./ClaimSubmitModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports